module.exports = __webpack_public_path__ + "static/manage@2x-5ec8a93478ba39031521b24a418a85f0.png";